module.exports = __webpack_public_path__ + "static/media/bank-account.1bd58a8c.png";